"use client";

import { useEffect } from "react";

import { updateClientMetaTag } from "../../utils/updateClientMetaTag";

const isEconomy = process.env.NEXT_PUBLIC_UI_THEME === "ekonomi";
const siteName = isEconomy ? "Omni Ekonomi" : "Omni";

const TopicsClientMetaData = ({
  isEconomy,
  topicId,
  topicSlug,
  topicTitle,
}: {
  isEconomy: boolean;
  topicId: string;
  topicSlug: string;
  topicTitle: string;
}) => {
  useEffect(() => {
    const updateLatestNewsMetaTags = () => {
      const siteUrl = isEconomy
        ? `https://omniekonomi.se/t/${topicSlug}/${topicId}`
        : `https://omni.se/t/${topicSlug}/${topicId}`;
      const description = `Senaste nytt om "${topicTitle}".`;
      const siteLogo = isEconomy
        ? "/images/logo-ekonomi.png"
        : "/images/logo-core.png";

      // Update the title
      document.title = topicTitle;

      // Update meta tags
      updateClientMetaTag("description", description);

      updateClientMetaTag("og:title", topicTitle, "property");
      updateClientMetaTag("og:description", description, "property");
      updateClientMetaTag("og:url", siteUrl, "property");
      updateClientMetaTag("og:site_name", siteName, "property");
      updateClientMetaTag("og:type", "website", "property");
      updateClientMetaTag("og:image", siteLogo, "property");
      updateClientMetaTag("og:locale", "sv_SE", "property");

      updateClientMetaTag("twitter:title", topicTitle, "name");
      updateClientMetaTag("twitter:description", description, "name");
      updateClientMetaTag(
        "twitter:site",
        isEconomy ? "@OmniEkonomi" : "@omni_red",
        "name",
      );
      updateClientMetaTag(
        "twitter:creator",
        isEconomy ? "@OmniEkonomi" : "@omni_red",
        "name",
      );
      updateClientMetaTag("twitter:image", siteLogo, "name");

      updateClientMetaTag("canonical", siteUrl, "property");
    };
    const shouldUpdateMetaTags = document.title !== topicTitle;

    if (shouldUpdateMetaTags) updateLatestNewsMetaTags();
  }, [isEconomy, topicId, topicSlug, topicTitle]);

  return null;
};

export { TopicsClientMetaData };
